export default __webpack_public_path__ + "1151935.png";